<template>
  <span>
    <sidebar-module-info
      ref="sidebarModuleInfo"
      module-name="folders"
      permissions-path="FOLDERS"
      :filtered-attributes="['id', 'name', 'added_by', 'added_at']"
      :module-objects="folders"
      :get-object="getFolderObject"
      :handle-object-adding="handleFolderAdd"
      :handle-object-deleting="deleteFolder"
      :handle-object-editing="handleFolderEditing"
      :inputs="inputs"
      :toggle-object-adding="toggleFolderAdding"
      :zoom-to-object="zoomToFolder"
      has-back-button
      has-basic-attributes
      :has-assigned-objects="false"
    >
      <template #folderContent="scope">
        <folder-content
          v-bind="scope"
          @documentUploaded="getFolderDocuments(currentFolderId)"
          :folder-documents="folderDocuments"
          :folderId="currentFolderId"
          :has-permissions="hasPermissions"
        >
        </folder-content>
      </template>
      <template #geometry="scope">
        <sidebar-geometry-input
          v-bind="scope"
          v-model="scope.payload[scope.name]"
          :is-valid.sync="scope.slotsValid[scope.name]"
        />
      </template>
    </sidebar-module-info>
  </span>
</template>

<script>
import SidebarModuleInfo from '@/components/SidebarModuleInfo';
import SidebarGeometryInput from '@/components/SidebarGeometryInput';
import { call, get } from 'vuex-pathify';
import FolderContent from '@/components/FolderContent';

export default {
  name: 'Folder',
  components: {
    FolderContent,
    SidebarModuleInfo,
    SidebarGeometryInput,
  },
  computed: {
    folders: get('layers/folders'),
    folderDocuments: get('layers/folderDocuments@:currentFolderId'),
    permissions: get('users/toolsPermissions'),
    hasPermissions() {
      return this.permissions['FOLDERS'].main_value > 1;
    },
    currentFolderId() {
      return this.$route.params.fid;
    },
    inputs() {
      return {
        new: [
          {
            name: 'name',
            translationPath: 'dialog.name',
            icon: '$label',
            dataType: { name: 'text' },
            rules: [v => !!v || v == '0' || 'rules.required'],
            hasDivider: true,
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            sectionTitle: 'sidebar.geometrySectionTitle',
            hasNameColumn: false,
            oneLineInput: false,
            cols: '12',
            hint: this.$i18n.t('dialog.folderGeometryInputHint'),
            geometryType: 'Polygon',
            assignGeometryType: 'Polygon',
            hasAssignGeometry: true,
            drawGeometryText: 'dialog.drawGeometry',
            hasDivider: true,
            assignGeometryText: 'dialog.assignPlot',
          },
        ],
        edit: [
          {
            name: 'name',
            translationPath: 'dialog.name',
            icon: '$label',
            dataType: { name: 'text' },
            rules: [v => !!v || v == '0' || 'rules.required'],
            hasDivider: true,
          },
          {
            name: 'folderContent',
            hasNameColumn: false,
            oneLineInput: false,
            hasIconColumn: false,
            cols: '12',
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            sectionTitle: 'sidebar.geometrySectionTitle',
            hasNameColumn: false,
            oneLineInput: false,
            cols: '12',
            hint: this.$i18n.t('dialog.folderGeometryInputHint'),
            geometryType: 'Polygon',
            assignGeometryType: 'Polygon',
            hasAssignGeometry: true,
            drawGeometryText: 'dialog.drawGeometry',
            hasDivider: true,
            assignGeometryText: 'dialog.assignPlot',
          },
        ],
      };
    },
  },
  methods: {
    getFolder: call('layers/getFolder'),
    addFolder: call('layers/addFolder'),
    deleteFolder: call('layers/deleteFolder'),
    editFolder: call('layers/editFolder'),
    getFolderDocuments: call('layers/getFolderDocuments'),
    toggleFolderAdding() {
      this.$router.push({
        name: 'folder',
        params: { fid: 'new' },
      });
    },
    zoomToFolder(layerId, layerGroup, featureId) {
      this.$root.$emit('zoomToFeature', layerId, layerGroup, featureId);
    },
    async getFolderObject(id) {
      const r = await this.getFolder(id);
      const object = {
        ...r.properties,
        ...{ id: r.id },
        ...{ geometry: { ...r.geometry, ...{ crs: r.crs } } },
      };
      return object;
    },
    async handleFolderEditing(payload) {
      const folder_id = payload.id;
      delete payload.id;
      const feature = {
        ...payload,
      };
      await this.editFolder({ folder_id, feature });
    },
    async handleFolderAdd(payload) {
      const dateNow = this.$dayjs();
      const dateNowIsoString = dateNow.format('YYYY-MM-DDTHH:mm[:00.000Z]');
      const feature = {
        ...payload,
        ...{ added_at: dateNowIsoString.slice(0, -1) },
      };
      const r = await this.addFolder(feature);
      return r.data.data;
    },
    async init() {
      if (this.currentFolderId !== 'new') {
        await this.getFolderDocuments(this.currentFolderId);
      }
    },
  },
  watch: {
    currentFolderId(nV) {
      if (nV !== 'new') {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
